import React, { useState, useEffect } from 'react';
import { Table, Thead, Tbody, Tr, Th, Td, chakra, Box, Text, Button, Flex, useToast, Center, Alert, Icon, IconButton, SimpleGrid, Slider, SliderTrack, SliderFilledTrack, Tooltip, SliderThumb, HStack } from '@chakra-ui/react'
import { useTable, useSortBy } from 'react-table'
import Cookies from 'universal-cookie';

import { FaRegCalendarTimes, FaAngleLeft, FaAngleRight, FaAngleDoubleLeft, FaAngleDoubleRight } from 'react-icons/fa';
import DatePicker from 'react-date-picker';
import '../css/DatePicker.css';
import '../css/Calendar.css';
import '../css/App.css'

import WebsiteHeader from '../GlobalComponents/WebsiteHeader';
import TableHead from '../GlobalComponents/TableHead';
import MapScreen from '../GlobalComponents/Map/MapScreen';

import CreateDevToken from './CreateDevToken';
import { ErrorToast, WarnToast, CheckToast } from '../GlobalComponents/CustomToast';
import { ActivityButton } from '../GlobalComponents/CustomButtons';
import DeviceRename from './DeviceRename';
import ChacraAlert from '../GlobalComponents/ChakraAlert';

export default function DevicePannel(props) {


    const [DeviceTable, setDeviceTable] = useState([]);
    const [ActiveDevice, setActiveDevice] = useState({})

    const [SingleActive, setSingleActive] = useState(null);
    const [ActivePolyline, setActivePolyline] = useState([]);
    const [ActiveRoute, setActiveRoute] = useState([]);


    const [MapData, setMapData] = useState([]);
    const [AddDrawer, setAddDrawer] = useState(false);
    const [RenameMod, setRenameMod] = useState(false);

    const [Date1, setDate1] = useState(new Date());
    const [Date2, setDate2] = useState(new Date());
    const [chacraAlert, setChacraAlert] = useState({ isOpen: false, header: 'Header', text: 'Description', closeBtn: 'cancel', actBtn: 'action', onClose: null, onAction: null });

    const toast = useToast();
    const toastIdRef = React.useRef();

    const deviceColors = [
        '#d60000',
        '#df6666',
    ]

    // ----- page Controller -----

    const [page, setPage] = useState(0);
    const [sliderValue, setSliderValue] = React.useState(1)
    const [showTooltip, setShowTooltip] = React.useState(false)

    const pageSize = 18;
    const start = page * pageSize;
    const end = start + pageSize;
    const totalPages = Math.ceil(DeviceTable.length / pageSize);
    const currentPageData = DeviceTable.slice(start, end);

    const handlePrev = () => updatePage(Math.max(0, page - 1));
    const handleNext = () => updatePage(Math.min(totalPages - 1, page + 1));

    const updatePage = (p) => {
        setSliderValue(p + 1)
        setPage(p)
    }


    /*const deviceColors = [
        '#ff4c4c',
        '#b14ccf',
        '#4a85bd'
    ]*/

    useEffect(() => {
        _fetchDevices();
    }, []);

    async function AddDrawerCall(comand, value1) {
        if (comand === 'back') {

            setAddDrawer(false)
        }

        if (comand === 'request') {

            setAddDrawer(false)
            NewDevToken(value1);
        }
    }

    function setAlert(header, text, closeButtonText, actionButtonText, func) {
        var Alert = { ...chacraAlert };
        Alert.isOpen = true;
        Alert.header = header;
        Alert.text = text
        Alert.closeBtn = closeButtonText
        Alert.actBtn = actionButtonText
        Alert.onClose = () => closeAlert();
        Alert.onAction = () => [closeAlert(), func()];
        setChacraAlert(Alert)
    }

    function closeAlert() {
        var Alert = { ...chacraAlert }; Alert.isOpen = false; setChacraAlert(Alert)
    }

    function disableTokenAlert(deviceID, deviceName, type, active) {

        if (deviceName !== '') {
            var device = deviceName + " (" + deviceID + ")"
        } else {
            var device = "id: " + deviceID
        }

        if (active) {
            setAlert(
                "Gerätetoken deaktivieren",
                "Den Gerätetoken für " + device + " wirklich deaktivieren?",
                "Abbrechen", "Deaktivieren", () => disableTokenHandler(deviceID, type)
            )
        } else {
            setAlert(
                "Gerätetoken aktivieren",
                "Den Gerätetoken für " + device + " erneut aktivieren?",
                "Abbrechen", "Aktivieren", () => enableTokenHandler(deviceID, type)
            )
        }
    }

    async function transformRoute(route) { //builds compute- and realRoute
        var basicArray = [];

        if (route && Array.isArray(route)) {
            route.forEach((item) => {
                basicArray.push([item.Latitude, item.Longitude])
            })
        }
        return basicArray;
    }

    function toLocalISODate(date) {
        const local = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        return local.toISOString().split('T')[0];
    }

    async function deviceRouteHandler() {

        if (!ActiveDevice || !ActiveDevice.DeviceID) {
            return false
        };
        if (!Date1 || !Date2) {
            toast({ render: () => (<WarnToast title='Datum Fehlerhaft' descr="Von/Bis Datumsangaben sind fehlerhaft!" />), status: 'warn', duration: 5000, isClosable: true, position: 'top', })
            return false
        };

        var start = toLocalISODate(Date1)
        var end = toLocalISODate(Date2)

        var method = 'loadDeviceRoute';
        var body = { DeviceID: ActiveDevice.DeviceID, StartTime: start, EndTime: end }
        var result = await sendData(method, '', body)
        //console.log(result)
        if (result !== false && result !== 'error') {
            var route = await transformRoute(result)
            setActivePolyline(route);
            setActiveRoute(result);
            makeSingleMarker();

        } else toast({ render: () => (<ErrorToast title='Abruf fehlgeschlagen!' descr="Geräte Route konnte nicht geladen werden!" />), status: 'error', duration: 5000, isClosable: true, position: 'top', })
    }

    async function renameHandler(value) {

        setRenameMod(false)
        //setActiveDevice({})

        if (!ActiveDevice.DeviceID || value == '' || value == ActiveDevice.Device_Name) {
            return
        }

        var method = 'UpdateUserDevice';
        var body = { DeviceID: ActiveDevice.DeviceID, DeviceName: value }
        var result = await sendData(method, '', body)
        if (result !== 'error' && result !== 'invalid') {
            //console.log(result)
            _fetchDevices()

        } else toast({ render: () => (<ErrorToast title='Abruf fehlgeschlagen!' descr="Gerät konnte nicht umbenannt werden!" />), status: 'error', duration: 5000, isClosable: true, position: 'top', })
    }

    async function disableTokenHandler(deviceId, type) {

        var Time = null
        var method = 'UpdateDevToken';
        var body = { DeviceID: deviceId, hasTime: Time }
        var result = await sendData(method, '', body)
        //console.log(result)
        if (result !== false && result !== 'invalid') {
            //console.log(result)
            _fetchDevices()
        } else toast({ render: () => (<ErrorToast title='Abruf fehlgeschlagen!' descr="Token konnte nicht deaktiviert werden!" />), status: 'error', duration: 5000, isClosable: true, position: 'top', })
    }

    async function enableTokenHandler(deviceId, accesType) {
        var Time = true
        var method = 'UpdateDevToken';
        var body = { DeviceID: deviceId, hasTime: Time }
        var result = await sendData(method, '', body)
        console.log(body)
        if (result !== false && result !== 'invalid') {
            //console.log(result)
            _fetchDevices()
        } else toast({ render: () => (<ErrorToast title='Abruf fehlgeschlagen!' descr="Token konnte nicht erneuert werden!" />), status: 'error', duration: 5000, isClosable: true, position: 'top', })
    }
    async function sendData(target, params, json = {}) {

        var url = props.server + '/API/index.php/' + target + params;
        const cookies = new Cookies();
        var UserToken = cookies.get('LoginToken');
        json.Token = UserToken;
        //console.log(json)
        try {
            const response = await fetch(url, {
                method: 'POST',
                //headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': 'Basic VHJhdmVsZXI6VGhpczEhSXMyIlRoZTPCp1Bhc3N3b3JkNCQ=' },
                body: JSON.stringify(json)
            });
            const results = await response.json();
            if (results.AuthKey === 'invalid') {
                props.searchCall('logOut')
            } else if (results.AuthKey === 'noRight') {
                toast({ render: () => (<WarnToast title='Berechtigungen Fehlerhaft' descr='Sie besitzen keine Berechtigung für diese Aktion!' />), status: 'error', duration: 5000, isClosable: true, position: 'top', })
                props.searchCall('newRights', results.Rights)
            } else return results
        } catch (error) { console.log(error) }
    }
    async function _fetchDevices() { //Load all Tables
        var data = await sendData('Web_LoadDevices', '', {})
        console.log(data);
        if (typeof data === 'object' && data !== null) {

            DevicePositionData(data.DeviceTable);
            setActivePolyline([]);
            setActiveRoute([]);
            setActiveDevice({})
            setSingleActive(null)

        } else toast({ render: () => (<ErrorToast title='Abruf fehlgeschlagen!' descr="Tabellendaten sind Fehlerhaft!" />), status: 'error', duration: 5000, isClosable: true, position: 'top', })
    }
    async function NewDevToken(DeviceID) { //set Token status

        var method = 'Web_CreateDevToken';
        var body = { DeviceID: DeviceID }
        var result = await sendData(method, '', body)
        console.log(result)
        if (result !== false && result !== 'invalid' && result !== 'error') {

            _fetchDevices()
        } else toast({ render: () => (<ErrorToast title='Abruf fehlgeschlagen!' descr="Dev-Token wurde nicht erstellt!" />), status: 'error', duration: 5000, isClosable: true, position: 'top' })
    }
    async function DevicePositionData(DevicePos) {

        for (let i = 0; i < DevicePos.length; i++) {

            DevicePos[i].Latitude = DevicePos[i].Last_Latitude
            DevicePos[i].Longitude = DevicePos[i].Last_Longitude
            DevicePos[i].AbladeID = DevicePos[i].DeviceID
            DevicePos[i].Index = i + 1
            DevicePos[i].color = deviceColors[i % 2]
        }

        setDeviceTable(DevicePos)
        setMapData(DevicePos);
    }
    function onRowPressed(row) {
        setActiveDevice(row);
        setActivePolyline([]);
        setActiveRoute([]);
        setSingleActive(null)
    }
    async function DeviceCenterPosition(DeviceID) { //changes first item in MapList for giveCenter

        var DevicePos = [...MapData];
        const idx = DevicePos.findIndex((item) => item.DeviceID === DeviceID);

        if (idx !== -1) {
            const item = DevicePos.splice(idx, 1)
            DevicePos.unshift(item[0]);
            setMapData(DevicePos);
        }
    }
    async function MapCall(comand, value1, value2) {
        if (comand === 'setMap') {
            props.searchCall('setMap', value1)
        }
    }
    async function makeSingleMarker() {

        var SingleMarker = {};

        SingleMarker.position = { Latitude: ActiveDevice.Last_Latitude, Longitude: ActiveDevice.Last_Longitude }
        SingleMarker.color = ActiveDevice.color
        SingleMarker.text = ActiveDevice.Index
        SingleMarker.tooltip = ActiveDevice.DeviceID !== false && ActiveDevice.DeviceID !== undefined ? (
            <>
                <Text fontSize='15px' isTruncated fontWeight='bold'>{ActiveDevice.Last_User}</Text>
                <Text fontSize='15px' isTruncated fontWeight={ActiveDevice.Last_User ? 400 : 700}>{ActiveDevice.Device_Name}</Text>
                <Text fontSize='15px' isTruncated fontWeight={ActiveDevice.Device_Name || ActiveDevice.Last_User ? 400 : 700}>{ActiveDevice.DeviceID}</Text>
                <Text fontSize='15px' isTruncated>{ActiveDevice.Last_Time}</Text>
            </>
        ) : (null)

        setSingleActive(SingleMarker);
    }

    async function _getsetPrevDay() {

        var date = new Date()
        const day = date.getDay();
        const daysToSubtract = day === 0 ? 2 : day === 1 ? 3 : 1;
        const previousWorkday = new Date(date);
        previousWorkday.setDate(date.getDate() - daysToSubtract);
        setDate1(previousWorkday);
        setDate2(date);
        //return [previousWorkday, date];
    }

    const acolumns = [
        { label: 'Geräte ID', accessor: 'DeviceID', sortable: true, width: 120, },
        { label: 'Gerätename', accessor: 'Device_Name', sortable: true, width: 60, },
        { label: 'IP Adresse', accessor: 'IP_Addr', sortable: true, width: 60, },
        { label: 'Benutzer', accessor: 'Last_User', sortable: true, width: 120, },
        { label: 'Aktualisiert', accessor: 'Last_Time', sortable: true, width: 120, },
        { label: 'Active', accessor: 'DevTokenSet', sortable: false, width: 60, }
    ]

    const sortDevice = (sortField, sortOrder) => {
        if (sortField) {
            const sorted = [...DeviceTable].sort((a, b) => {
                if (a[sortField] === null) return 1;
                if (b[sortField] === null) return -1;
                if (a[sortField] === null && b[sortField] === null) return 0;
                return (
                    a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
                        numeric: true,
                    }) * (sortOrder === "asc" ? 1 : -1)
                );
            });
            setDeviceTable(sorted);
        }
    };
    return (
        <Flex flexDirection='column' height='100vh'>
            <WebsiteHeader Text='TourPortal / Geräte verwalten' onClick={() => props.searchCall('back')}
                server={props.server} User={props.ActiveUser} />
            <Flex flex={1} backgroundColor='#ccc' p={1} overflowY='auto' >
                <Flex width='45%' flexDirection='column' overflow='auto'>

                    <Box flex={2} borderWidth={1} borderRadius={3} borderColor='#000'>
                        <MapScreen
                            MapCall={MapCall}
                            editMap={false}
                            ActiveUser={props.ActiveUser}

                            DeviceData={!SingleActive ? MapData : []}
                            SingleMarker={SingleActive}
                            ExtraRoute={SingleActive ? { polyline: ActivePolyline, color: ActiveDevice.color, routeData: ActiveRoute } : false}
                        />
                    </Box>
                    <Box flex={1} borderWidth={1} borderRadius={3} borderColor='#000' bgColor='#fff' padding={2} mt={1}
                        overflow="hidden" >

                        <Flex alignItems='center' justifyContent='space-between' >

                            <Flex alignItems='center'>
                                {ActiveDevice.Device_Name !== '' ? (
                                    <Text m={1} color='#222' fontSize={22} fontWeight='bold'>{ActiveDevice.Device_Name}</Text>
                                ) : null}
                                <Text m={1} color='#222' fontSize={19}> {ActiveDevice.DeviceID}</Text>
                            </Flex>

                            <Flex m={1} width='500px' minHeight='40px' border='0px solid black' alignItems='center' justifyContent='space-evenly' borderRadius={6} bg='#1DA1F2' flexWrap='wrap'>
                                <IconButton bg='#1DA1F2' color='#fff' width='40px'
                                    icon={<Icon as={FaRegCalendarTimes} color='#fff' boxSize={25} />} onClick={() => _getsetPrevDay()}
                                    borderRadius='5px 0px 0px 5px' colorScheme='blue' />
                                <Text color='#fff' fontWeight='semibold' fontSize={17} mx={1} >von:</Text>
                                <DatePicker onChange={setDate1} value={Date1} format='dd.MM.y' border='0px solid black' />
                                <Text color='#fff' fontWeight='semibold' fontSize={17} mx={1} >bis:</Text>
                                <DatePicker onChange={setDate2} value={Date2} format='dd.MM.y' border='0px solid black' />
                                <Button bg='#1DA1F2' color='#fff' ml={1} fontSize={19} onClick={() => deviceRouteHandler()} width='60px' mr={1}
                                    borderRadius='5px'>Laden</Button>
                            </Flex>
                        </Flex>
                        <Flex>
                            <Text m={1} color='#222' fontSize={17}>
                                {SingleActive ? (ActivePolyline.length > 0 ? "Polyline geladen" : "keine Polyline vorhanden") : ""}
                            </Text>
                        </Flex>
                    </Box>
                </Flex>
                <Flex ml={1} width='55%' borderWidth={1} borderRadius={3} borderColor='#000' bgColor='#fff' padding={2}
                    overflow="hidden" flexDirection='column' justifyContent='space-between'
                >
                    <Flex overflowY='auto' >
                        <Table size="small" variant='' colorScheme='blackAlpha' sx={{ tableLayout: "auto" }} >
                            <TableHead {...{ columns: acolumns, handleSorting: sortDevice }} />
                            <Tbody>
                                {currentPageData.map((row, idx) => {
                                    return (
                                        <Tr key={row.DeviceID} maxHeight='30px'
                                            onClick={() => [onRowPressed(row), DeviceCenterPosition(row.DeviceID)]}
                                            border={ActiveDevice.DeviceID === row.DeviceID ? '3px dashed #0060d5' : null}
                                        >

                                            <Td borderWidth={1} h='30px' justifyContent='flex-start' width='20%'>
                                                <Flex justifyContent='space-between' alignItems='center' flexDirection='row' mr={1} ml={1}>
                                                    <Flex width='40px' justifyContent='center' alignItems='center' borderRadius={10} style={{ backgroundColor: row.color + 'bb' }}>
                                                        <Text noOfLines={1} fontSize={19} fontWeight={700}>{row.Index}</Text>
                                                    </Flex>
                                                    <Text noOfLines={1} fontSize={17} >{row.DeviceID}</Text>
                                                </Flex>
                                            </Td>
                                            <Td className="columnResizer" />
                                            <Td borderWidth={1} h='30px' justifyContent='flex-start' width='15%'>
                                                <Flex justifyContent='center' alignItems='center' flexDirection='row' m={1}>
                                                    <Button colorScheme="gray" variant='ghost' height='30px' fontWeight={400} fontSize={17} mr={1} padding={1}
                                                        onClick={() => (setRenameMod(!RenameMod))}
                                                    >
                                                        {row.Device_Name !== '' ? row.Device_Name : '...'}
                                                    </Button>
                                                </Flex>
                                            </Td>
                                            <Td className="columnResizer" />
                                            <Td borderWidth={1} h='30px' justifyContent='flex-start' flex={1} width='20%'>
                                                <Flex justifyContent='center' alignItems='center' flexDirection='row' m={1}>
                                                    <Text noOfLines={1} fontSize={17} wordBreak='break-word' >{row.IP_Addr}</Text>
                                                </Flex>
                                            </Td>
                                            <Td className="columnResizer" />
                                            <Td borderWidth={1} h='30px' justifyContent='flex-start' width='20%'>
                                                <Flex justifyContent='center' alignItems='center' flexDirection='row' m={1} >
                                                    <Text noOfLines={1} fontSize={17} >{row.Last_User}</Text>
                                                </Flex>
                                            </Td>
                                            <Td className="columnResizer" />
                                            <Td borderWidth={1} h='30px' justifyContent='flex-start' width='20%' >
                                                <Flex justifyContent='center' alignItems='center' flexDirection='row' m={1} >
                                                    <Text noOfLines={1} fontSize={17} >{row.Last_Time}</Text>
                                                </Flex>
                                            </Td>
                                            <Td className="columnResizer" />
                                            <Td borderWidth={1} h='30px' justifyContent='flex-start' width='5%'>
                                                <Flex justifyContent='center' alignItems='center' flexDirection='row' m={1} >
                                                    <ActivityButton size={25} on={row.DevTokenSet | 0} onClick={() => disableTokenAlert(row.DeviceID, row.Device_Name, 'Dev', row.DevTokenSet)} />
                                                </Flex>
                                            </Td>

                                            {/*acolumns.map(({ accessor, width }) => {
                                                const tData = row[accessor];
                                                return (<React.Fragment key={accessor}>
                                                    <Td textAlign="center" borderWidth={1} h='50px' w={width} bgColor={'#fff'}>

                                                        {accessor === 'DevTokenSet' && tData !== false ? (
                                                            <Button colorScheme='blue'
                                                                onClick={() => OnTokenSetPress(row.DevToken, row.DevTokenSet, row.DeviceID)}
                                                            >{tData}</Button>
                                                        ) : accessor === 'DeviceID' && tData !== false ? (
                                                            <Button colorScheme="blue" variant='ghost' fontWeight={400}
                                                                onClick={() => DeviceCenterPosition(row.DeviceID)}
                                                            >{tData}</Button>
                                                        ) : (
                                                            <Text wordBreak='break-all' noOfLines={1}>{tData}</Text>
                                                        )}

                                                    </Td>
                                                    <Td className="columnResizer" />
                                                </React.Fragment>);
                                            })*/}
                                        </Tr>
                                    );
                                })}
                            </Tbody>
                        </Table>
                    </Flex>
                    <Flex width='100%' justifyContent='space-evenly' alignItems='center' >

                        {totalPages > 1 ? (
                            <Box display='flex' flexDirection='column' alignItems='center' justifyContent='center' overflow='auto'>
                                <HStack justify="space-between" mt={4}>

                                    <IconButton bg='#1DA1F2' borderRadius='5px' color='#fff' width='20px'
                                        onClick={() => updatePage(0)} isDisabled={page === 0}
                                        icon={<Icon as={FaAngleDoubleLeft} boxSize={25} />} />
                                    <IconButton bg='#1DA1F2' borderRadius='5px' color='#fff' width='20px'
                                        onClick={handlePrev} isDisabled={page === 0}
                                        icon={<Icon as={FaAngleLeft} boxSize={25} />} />

                                    <Text style={{ fontSize: 23 }}>Seite {page + 1} von {totalPages}</Text>

                                    <IconButton bg='#1DA1F2' borderRadius='5px' color='#fff' width='20px'
                                        onClick={handleNext} isDisabled={page === totalPages - 1}
                                        icon={<Icon as={FaAngleRight} boxSize={25} />} />
                                    <IconButton bg='#1DA1F2' borderRadius='5px' color='#fff' width='20px'
                                        onClick={() => updatePage(totalPages - 1)} isDisabled={page === totalPages - 1}
                                        icon={<Icon as={FaAngleDoubleRight} boxSize={25} />} />

                                </HStack>

                                <Slider
                                    height='50px'
                                    width='300px'
                                    id='slider'
                                    defaultValue={1}
                                    min={1}
                                    max={totalPages}
                                    value={sliderValue}
                                    color='#fff'
                                    onChangeEnd={(val) => setPage(val - 1)}
                                    onChange={(v) => setSliderValue(v)}
                                    onMouseEnter={() => setShowTooltip(true)}
                                    onMouseLeave={() => setShowTooltip(false)}
                                >
                                    <SliderTrack>
                                        <SliderFilledTrack />
                                    </SliderTrack>
                                    <Tooltip
                                        hasArrow
                                        color='#fff'
                                        placement='top'
                                        isOpen={showTooltip}
                                        label={sliderValue}
                                    >
                                        <SliderThumb>
                                            <Box height="20px" width="20px" borderWidth={3} borderColor="#1DA1F2" />
                                        </SliderThumb>
                                    </Tooltip>
                                </Slider>
                            </Box>
                        ) : (null)}

                        <Button width={200} colorScheme='blue' mt='10px' onClick={() => setAddDrawer(true)}>Dev-Token Hinzufügen</Button>
                    </Flex>
                </Flex>
            </Flex >

            <CreateDevToken isOpen={AddDrawer} onClose={() => AddDrawerCall('back')} AddDrawerCall={AddDrawerCall} />
            <DeviceRename isOpen={RenameMod} onClose={() => setRenameMod(false)} onConfirm={renameHandler} device={ActiveDevice} />
            <ChacraAlert Alert={chacraAlert} />

        </Flex>
    )
}